import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://rdhrqobmsuykmoyxjaor.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJkaHJxb2Jtc3V5a21veXhqYW9yIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzgxNTkwMTQsImV4cCI6MTk5MzczNTAxNH0.X5nvWs98nxpQvT78AJRZie9hu2SsHJkZZ-hvdavzUVo";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
